export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* image */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20laptop%20open%20to%20an%20article%20page%20on%20a%20rustic%20wooden%20desk%20with%20a%20cup%20of%20tea%20and%20a%20small%20potted%20plant%2C%20documentary%20magazine%20style%2C%20cream%20amber%20and%20terracotta%20tones%2C%20soft%20morning%20light%2C%20no%20people%20visible%2C%20calm%20storytelling%20mood&width=900&height=820&seq=dashan-about-01&orientation=portrait"
                alt="编辑部写作场景：笔记本上摊开的深度稿件与一杯热茶"
                className="w-full h-[360px] lg:h-[520px] object-cover"
              />
            </div>
          </div>

          {/* copy */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <p className="text-primary-600 font-semibold tracking-wide text-sm">ABOUT · 关于我们</p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
              搭讪吃瓜：把热闹聊出清醒
            </h2>

            <div className="mt-6 space-y-4 text-foreground-600 leading-7">
              <p>
                <span className="font-semibold text-foreground-950">我们是谁。</span>
                搭讪吃瓜是一档聚焦「街头搭讪实拍内容」的独立观察媒体。当这类视频一次次冲上热门又引发争议，
                我们希望提供一个不吵嚷、不站队、肯深挖的讨论空间，陪你把每一次吃瓜都吃明白。
              </p>
              <p>
                <span className="font-semibold text-foreground-950">我们的立场。</span>
                我们主张记录真实生活，但坚决反对以消费陌生路人、制造其尴尬与不适为代价的流量创作。
                话题热度背后，被拍者的人格尊严与个人信息权益，永远值得被认真对待。
              </p>
              <p>
                <span className="font-semibold text-foreground-950">我们怎么写。</span>
                编辑严格遵循：先厘清事实再谈立场、多方观点同屏呈现、涉及个案一律去标识化并征得同意、
                对拿不准的法律表述主动标注"视个案而定"。我们不制造对立，只负责把逻辑讲清楚。
              </p>
            </div>

            {/* values */}
            <div className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {[
                { icon: "ri-eye-line", t: "事实先于立场", d: "不先入为主" },
                { icon: "ri-speak-line", t: "多方同屏", d: "拒绝单向输出" },
                { icon: "ri-shield-check-line", t: "去标识保护", d: "个案务必脱敏" },
              ].map((v) => (
                <div key={v.t} className="p-4 rounded-2xl bg-background-100 border border-background-200">
                  <i className={`${v.icon} text-2xl text-accent-500`}></i>
                  <h3 className="mt-2 font-heading text-base font-bold text-foreground-950">{v.t}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{v.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* social proof strip */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { q: "把网上吵不清的隐私边界讲得这么明白，收藏了慢慢看。", name: "关注隐私的读者", mark: "· 微博网友" },
            { q: "难得见到一个劝创作者别拿路人当素材的号，立场清晰、有依据。", name: "内容观察者", mark: "· 知乎用户" },
            { q: "吃瓜之余学到怎么给自己维权，这类内容再多些就好了。", name: "曾被拍摄的读者", mark: "· 站内留言" },
          ].map((p) => (
            <figure key={p.name} className="p-5 rounded-2xl bg-background-100 border border-background-200">
              <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
              <blockquote className="mt-2 text-[15px] leading-7 text-foreground-800">{p.q}</blockquote>
              <figcaption className="mt-3 text-sm text-foreground-500">
                <span className="font-medium text-foreground-700">{p.name}</span> {p.mark}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}